import { fromJS } from "immutable";
import { uniqBy } from "lodash";
import { DataFormatter } from "./Data/Fotmatter";
import { filterDataWithDesc } from "./Data/FilterDropDownData";
import apiDataFormatter from "./formatter";
import * as actionTypes from "./actionTypes";
import {
  getUserDetailsType,
  getDropdownValuesType,
  fetchRelationDropDownSuccessType
} from "../../../actions/globalActionTypes";

const InitialState = fromJS({
  webAccessInfo: {
    fundName: "",
    userId: ""
  },
  secondaryAdvisorInfo: {},
  primaryAdvisor: {
    email: {},
    phone: {},
    addresses: {},
    relatedDonor: [],
    info: {},
    reset: false,
    disable: false,
  },
  secondaryAdvisor: {
    email: {},
    phone: {},
    addresses: {},
    relatedDonor: {},
    info: {},
    reset: false,
  },
  dropdownValues: {
    data: {},
  },
  advisorCount: {
    count: 1,
    createCount: 1,
    charityCount: 1,
  },
  fundName: {},
  fundNameUsedForNPAStatus: false,
  error: {
    accountNameError: null,
  },
  legacyOptions: {},
  showRemainingPercentage: {},
  shouldClose: {},
  hasfeildvalues: false,
  isSecondaryAdvisor: {},
  showMore: {},
  isStep1Edit: {},
  isStep2Edit: {},
  finalJSON: {},
  estimatedInitialContribution: {},
  shouldEmptyZip: {},
  tempJSON: {},
  apiStatus: "",
  apiIndicator: false,
  status: "",
  validationCheck: false,
  accountDetails: {},
  accNum: "",
  selectedAccount: { accountId: "" },
  options: [],
  accordionStatus: false,
  updateButtonStepTwo: false,
  successortab: "",
  tempInfo: {},
  tempCheckBoxStatus: {},
  apiLoader: true,
  accordionOpenStatus: true,
  accordionStates: [0, 0, 0, 0, 0],
  alerts: [],
  editCity: false
});

export const npaFormReducer = (state = InitialState, action) => {
  switch (action.type) {
    case actionTypes.resetData:
      return state
        .setIn(["primaryAdvisor", "phone"], {})
        .setIn(["primaryAdvisor", "email"], {})
        .setIn(["primaryAdvisor", "addresses"], {})
        .setIn(["primaryAdvisor", "relatedDonor"], {})
        .setIn(["secondaryAdvisor", "phone"], {})
        .setIn(["secondaryAdvisor", "email"], {})
        .setIn(["secondaryAdvisor", "addresses"], {})
        .setIn(["legacyOptions"], {})
        .setIn(["accordionOpenStatus"], true)
        .setIn(["accordionStates"], [0, 0, 0, 0, 0])
        .setIn(["apiLoader"], true)
        .setIn(["apiStatus"], false);

    case actionTypes.storeChnagesStepOneReducer:
      let primaryAdvisor = {
        addresses: action.payload[0].addresses,
        phone: action.payload[0].phones,
        email: action.payload[0].emails,
        relatedDonor: action.payload[0].relatedDonor,
        remAddressPA: action.payload[0].remAddressPA,
        info: {
          deliveryMethod: action.payload[0].deliveryMethod,
          dob: action.payload[0].dob,
          firstname: action.payload[0].firstname,
          gender: action.payload[0].gender,
          lastname: action.payload[0].lastname,
          middlename: action.payload[0].middlename,
          ssn: action.payload[0].ssn,
          suffix: action.payload[0].suffix,
          title: action.payload[0].title,
          name: action.payload[0].name,
        },
      };
      if (action.payload.length === 1) {
        return state
          .set("primaryAdvisor", primaryAdvisor)
          .setIn(["secondaryAdvisor", "info"], {
            deliveryMethod: "E-Delivery",
            dob: "",
            firstname: null,
            gender: "",
            lastname: null,
            middlename: null,
            ssn: null,
            suffix: "",
            title: "",
          })
          .setIn(
            ["secondaryAdvisor", "addresses"],
            [
              {
                addressId: 0,
                addresstype: undefined,
                city: null,
                country: null,
                line1: null,
                line2: null,
                line3: null,
                state: undefined,
                zipcode: null,
                primary: true,
              },
            ]
          )
          .setIn(
            ["secondaryAdvisor", "email"],
            [
              {
                emailId: null,
                emailtype: undefined
              },
            ]
          )
          .setIn(
            ["secondaryAdvisor", "phone"],
            [
              {
                phonenumber: null,
                phonetype: undefined
              },
            ]
          );
      }
      if (action.payload.length >= 1) {
        return state
          .set("primaryAdvisor", primaryAdvisor)
          .setIn(["secondaryAdvisor", "addresses"], action.payload[1].addresses)
          .setIn(["secondaryAdvisor", "phone"], action.payload[1].phones)
          .setIn(["secondaryAdvisor", "email"], action.payload[1].emails)
          .setIn(["secondaryAdvisor", "info"], {
            deliveryMethod: action.payload[1].deliveryMethod,
            dob: action.payload[1].dob,
            firstname: action.payload[1].firstname,
            gender: action.payload[1].gender,
            lastname: action.payload[1].lastname,
            middlename: action.payload[1].middlename,
            ssn: action.payload[1].ssn,
            suffix: action.payload[1].suffix,
            title: action.payload[1].title,
          })
          .setIn(["tempCheckBoxStatus"], action.payload[2]);
      }

    case actionTypes.submitFormError:
      return state
        .setIn(["apiStatus"], false);      

    case actionTypes.validationCheckStatus:
      return state.setIn(["validationCheck"], action.payload);

    case actionTypes.oaaSubmitLoader:
      return state.setIn(["apiIndicator"], true);

    case actionTypes.hideSubmitLoader:
      return state.setIn(["apiIndicator"], false);

    case actionTypes.fetchAlertSuccess:
      return state.setIn(["alerts"], action.payload);

    case actionTypes.fetchAlertError:
      return state.setIn(["alerts"], []);

    case actionTypes.closeFormModal:
      return state.setIn(["apiStatus"], false);
    case actionTypes.submitFormSuccess:
      let accountDetailsOne = action.payload;
      return state
        .setIn(["apiStatus"], true)
        .setIn(["accNum"], accountDetailsOne.accountNumber)
        .setIn(["primaryAdvisor", "phone"], {})
        .setIn(["primaryAdvisor", "email"], {})
        .setIn(["primaryAdvisor", "addresses"], {})
        .setIn(["primaryAdvisor", "relatedDonor"], {})
        .setIn(["secondaryAdvisor", "phone"], {})
        .setIn(["secondaryAdvisor", "email"], {})
        .setIn(["secondaryAdvisor", "addresses"], {})
        .setIn(["legacyOptions"], {});

    case actionTypes.storeFeildValues:
      return state.setIn(["hasfeildvalues"], action.payload);
    case actionTypes.preFillValuePrimary:
      return state.setIn(["primaryAdvisor", "email"], action.payload);

    case actionTypes.preFillValueSecondary:
      return state.setIn(["secondaryAdvisor", "email"], action.payload);

    case actionTypes.onChangeValuesEmail:
      let obj = Object.keys(action.payload);
      return state.setIn([obj[0], "email"], action.payload[obj[0]]);

    case actionTypes.resetFormValuesEmail:
      let obj1 = Object.keys(action.payload);
      return state.setIn([obj1[0], "email"], action.payload[obj1[0]]);

    case actionTypes.resetFormValuesRelatedContributor:
      let obj2 = Object.keys(action.payload);
      return state.setIn([obj2[0], "relatedDonor"], action.payload[obj2[0]]);

    case actionTypes.preFillValueAddressPrimary:
      return state.setIn(["primaryAdvisor", "addresses"], action.payload);

    case actionTypes.preFillValueAddressSecondary:
      return state.setIn(["secondaryAdvisor", "addresses"], action.payload);

    case actionTypes.onChangeValuesAddress:
      let obj3 = Object.keys(action.payload);
      return state.setIn([obj3[0], "addresses"], action.payload[obj3[0]]);

    case actionTypes.resetFormValuesAddress:
      let obj4 = Object.keys(action.payload);
      return state.setIn([obj4[0], "addresses"], action.payload[obj4[0]]);

    case actionTypes.preFillValuePhonePrimary:
      return state.setIn(["primaryAdvisor", "phone"], action.payload);

    case actionTypes.preFillValuePhoneSecondary:
      return state.setIn(["secondaryAdvisor", "phone"], action.payload);

    case actionTypes.onChangeValuesPhone:
      let obj5 = Object.keys(action.payload);
      return state.setIn([obj5[0], "phone"], action.payload[obj5[0]]);

    case actionTypes.resetFormValuesPhone:
      let obj6 = Object.keys(action.payload);
      return state.setIn([obj6[0], "phone"], action.payload[obj6[0]]);

    case actionTypes.preFillValueInfoPrimary:
      return state.setIn(["primaryAdvisor", "info"], action.payload);

    case actionTypes.preFillValueInfoSecondary:
      return state.setIn(["secondaryAdvisor", "info"], action.payload);

    case actionTypes.inputInfo:
      let obj7 = Object.keys(action.payload);
      return state.setIn(
        ["secondaryAdvisor", "info", obj7[0]],
        action.payload[obj7[0]]
      );

    case actionTypes.resetFormValuesInfo:
      let obj8 = Object.keys(action.payload);
      return state.setIn([obj8[0], "info"], action.payload[obj8[0]]);

    case actionTypes.radioChangePrimary:
      return state.setIn(
        ["primaryAdvisor", "info", "deliveryMethod"],
        action.payload.deliveryMethod
      );

    case actionTypes.radioChangeSecondary:
      return state.setIn(
        ["secondaryAdvisor", "info", "deliveryMethod"],
        action.payload.deliveryMethod
      );

    case actionTypes.resetVariable:
      let obj9 = Object.keys(action.payload);
      return state.setIn([obj9[0], "reset"], action.payload[obj9[0]]);

    case actionTypes.addAdvisorButtonDisable:
      return state.setIn(["primaryAdvisor", "disable"], action.payload.disable);
    case actionTypes.storePrimaryInfo:
      let obj10 = Object.keys(action.payload);
      return state.setIn(
        ["primaryAdvisor", "info", obj10[0]],
        action.payload[obj10[0]]
      );

    case getUserDetailsType:
      let formattedData = apiDataFormatter(action.payload);
      let tempPrimaryObject = {
        addresses: {
          addresses: DataFormatter(
            formattedData.advisors
              .filter((data) => {
                if (data.primary === true) {
                  return data;
                }
              })
              .map((data) => {
                return data.addresses;
              })[0],
            "addresses"
          ),
        },
        email: {
          email: DataFormatter(
            formattedData.advisors
              .filter((data) => {
                if (data.primary === true) {
                  return data;
                }
              })
              .map((data) => {
                return data.emails;
              })[0],
            "email"
          ),
        },
        phone: {
          phone: DataFormatter(
            formattedData.advisors
              .filter((data) => {
                if (data.primary === true) {
                  return data;
                }
              })
              .map((data) => {
                return data.phones;
              })[0],
            "phone"
          ),
        },
        info: {
          name: formattedData.advisors[0].name,
          title: formattedData.advisors[0].title,
          firstname: formattedData.advisors[0].firstname,
          middlename: formattedData.advisors[0].middlename,
          lastname: formattedData.advisors[0].lastname,
          suffix: formattedData.advisors[0].suffix,
          gender: formattedData.advisors[0].gender,
          dob: formattedData.advisors[0].dob,
          ssn: formattedData.advisors[0].ssn,
          deliveryMethod: formattedData.advisors[0].deliveryMethod,
        },
        relatedDonor: {
          relatedDonor: DataFormatter(
            formattedData.advisors
              .filter((data) => {
                if (data.primary === true) {
                  return data;
                }
              })
              .map((data) => {
                return data.relatedDonor;
              })[0],
            "relatedDonor"
          ),
        },
      };

      let tempSecondaryObject = {
        addresses: {
          addresses: [
            {
              addresstype: "",
              line1: "",
              line2: "",
              line3: "",
              state: "",
              city: "",
              zipcode: "",
              country: "0",
              key: 0,
              primary: true,
            },
          ],
        },
        email: {
          email: [
            {
              emailtype: "",
              emailId: "",
              key: 0,
              primary: true,
            },
          ],
        },
        phone: {
          phone: [
            {
              phonetype: "",
              phonenumber: "",
              key: 0,
              primary: true,
            },
          ],
        },
        info: {
          name: "",
          title: "",
          firstname: "",
          lastname: "",
          middlename: "",
          suffix: "",
          gender: "",
          dob: "",
          key: 0,
          ssn: "",
          confirmSSN: "",
          deliveryMethod: "E-Delivery",
        },
      };

      return state
        .setIn(["primaryAdvisor"], tempPrimaryObject)
        .setIn(["secondaryAdvisor"], tempSecondaryObject)
        .setIn(["tempInfo"], {
          deliveryMethod: formattedData.advisors[0].deliveryMethod,
          dob: formattedData.advisors[0].dob,
          firstname: formattedData.advisors[0].firstname,
          gender: formattedData.advisors[0].gender,
          lastname: formattedData.advisors[0].lastname,
          middlename: formattedData.advisors[0].middlename,
          ssn: formattedData.advisors[0].ssn,
          suffix: formattedData.advisors[0].suffix,
          title: formattedData.advisors[0].title,
          name: formattedData.advisors[0].name,
        })
        .setIn(["webAccessInfo", "fundName"], formattedData.fundName)
        .setIn(["webAccessInfo", "userId"], formattedData.userId)
        .setIn(["apiLoader"], false);

    case getDropdownValuesType:
      let dropdownValues = {
        title: uniqBy(action.payload.title, "desc"),
        suffix: uniqBy(action.payload.suffix, "desc"),
        phoneType: action.payload.phoneAddressTypes,
        emailType: action.payload.emaileAddressTypes,
        addressType: action.payload.postalAddressTypes,
        countries: action.payload.countries,
        gender: [
          { value: "M", desc: "Male" },
          { value: "F", desc: "Female" },
          { value: "U", desc: "Other" },
        ],
        states: action.payload.states,
        dollarPotential: action.payload.dollarPotential,
      };

      dropdownValues.title.unshift({ value: "", desc: "--" });
      dropdownValues.suffix.unshift({ value: "", desc: "--" });

      return state
        .setIn(["dropdownValues", "data"], dropdownValues)
        .setIn(["apiLoader"], false);
    case actionTypes.fetchZipCode:
      if (action.payload.fetchPayload.stepnum === 2) {
        if (action.payload.response) {
          let countryData = "";
          if (action.payload.response.country === "US") {
            countryData = "United States";
          }
          let data = filterDataWithDesc(
            countryData,
            state.getIn(["dropdownValues", "data", "countries"])
          );
          if (state.getIn(["tempJSON", "tempJSON", "tempJSON"])) {
            let index;
            if (action.payload.fetchPayload.path === "primaryAdvisor") {
              index = 0;
            } else index = 1;
            let successorAdvisor;
            if (
              action.payload.fetchPayload.contentKey === 0 ||
              action.payload.fetchPayload.contentKey === 1
            ) {
              successorAdvisor = "successorAdvisor";
            } else {
              successorAdvisor = "successionPlanGranteeOrg";
            }
            return state
              .setIn(
                [
                  "tempJSON",
                  "tempJSON",
                  "tempJSON",
                  "legacyOptions",
                  `${action.payload.fetchPayload.contentKey}`,
                  `${successorAdvisor}`,
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "city",
                ],
                action.payload.response.city
                  .toLowerCase()
                  .charAt(0)
                  .toUpperCase() +
                  action.payload.response.city.toLowerCase().slice(1)
              )
              .setIn(
                [
                  "tempJSON",
                  "tempJSON",
                  "tempJSON",
                  "legacyOptions",
                  `${action.payload.fetchPayload.contentKey}`,
                  `${successorAdvisor}`,
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "state",
                ],
                action.payload.response.state
              )
              .setIn(
                [
                  "tempJSON",
                  "tempJSON",
                  "tempJSON",
                  "legacyOptions",
                  `${action.payload.fetchPayload.contentKey}`,
                  `${successorAdvisor}`,
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "country",
                ],
                data[0].value
              )
              .setIn(["shouldEmptyZip", "shouldEmptyZip"], {
                shouldEmptyZip: true,
              });
          } else {
            return state
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "legacyOptions",
                  "legacyOptions",
                  `${action.payload.fetchPayload.contentKey}`,
                  `successorAdvisor`,
                  "successorAdvisor",
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "city",
                ],
                action.payload.response.city
                  .toLowerCase()
                  .charAt(0)
                  .toUpperCase() +
                  action.payload.response.city.toLowerCase().slice(1)
              )
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "legacyOptions",
                  "legacyOptions",
                  `${action.payload.fetchPayload.contentKey}`,
                  `successorAdvisor`,
                  "successorAdvisor",
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "state",
                ],
                action.payload.response.state
              )
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "legacyOptions",
                  "legacyOptions",
                  `${action.payload.fetchPayload.contentKey}`,
                  `successorAdvisor`,
                  "successorAdvisor",
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "country",
                ],
                data[0].value
              )
              .setIn(["shouldEmptyZip", "shouldEmptyZip"], {
                shouldEmptyZip: true,
              });
          }
        } else {
          if (state.getIn(["tempJSON", "tempJSON", "tempJSON"])) {
            let index;
            if (action.payload.fetchPayload.path === "primaryAdvisor") {
              index = 0;
            } else index = 1;
            let successorAdvisor;
            if (
              action.payload.fetchPayload.contentKey === 0 ||
              action.payload.fetchPayload.contentKey === 1
            ) {
              successorAdvisor = "successorAdvisor";
            } else {
              successorAdvisor = "successionPlanGranteeOrg";
            }
            return state
              .setIn(
                [
                  "tempJSON",
                  "tempJSON",
                  "tempJSON",
                  "legacyOptions",
                  `${action.payload.fetchPayload.contentKey}`,
                  `${successorAdvisor}`,
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "city",
                ],
                undefined
              )
              .setIn(
                [
                  "tempJSON",
                  "tempJSON",
                  "tempJSON",
                  "legacyOptions",
                  `${action.payload.fetchPayload.contentKey}`,
                  `${successorAdvisor}`,
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "state",
                ],
                undefined
              )
              .setIn(
                [
                  "tempJSON",
                  "tempJSON",
                  "tempJSON",
                  "legacyOptions",
                  `${action.payload.fetchPayload.contentKey}`,
                  `${successorAdvisor}`,
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "country",
                ],
                undefined
              )
              .setIn(["shouldEmptyZip", "shouldEmptyZip"], {
                shouldEmptyZip: false,
              });
          } else {
            return state
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "legacyOptions",
                  "legacyOptions",
                  `${action.payload.fetchPayload.contentKey}`,
                  `successorAdvisor`,
                  "successorAdvisor",
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "city",
                ],
                undefined
              )
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "legacyOptions",
                  "legacyOptions",
                  `${action.payload.fetchPayload.contentKey}`,
                  `successorAdvisor`,
                  "successorAdvisor",
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "state",
                ],
                undefined
              )
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "legacyOptions",
                  "legacyOptions",
                  `${action.payload.fetchPayload.contentKey}`,
                  `successorAdvisor`,
                  "successorAdvisor",
                  `${action.payload.fetchPayload.index}`,
                  "address",
                  "country",
                ],
                undefined
              )
              .setIn(["shouldEmptyZip", "shouldEmptyZip"], {
                shouldEmptyZip: false,
              });
          }
        }
      } else {
        if (action.payload.response) {
          let countryData = "";
          if (action.payload.response.country === "US") {
            countryData = "United States";
          }
          let data = filterDataWithDesc(
            countryData,
            state.getIn(["dropdownValues", "data", "countries"])
          );
          if (state.getIn(["tempJSON", "tempJSON", "tempJSON"])) {
            let index;
            if (action.payload.fetchPayload.path === "primaryAdvisor") {
              index = 0;
            } else index = 1;
            return state
              .setIn(
                [
                  "tempJSON",
                  "tempJSON",
                  "tempJSON",
                  "advisors",
                  `${index}`,
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "city",
                ],
                action.payload.response.city
                  .toLowerCase()
                  .charAt(0)
                  .toUpperCase() +
                  action.payload.response.city.toLowerCase().slice(1)
              )
              .setIn(
                [
                  "tempJSON",
                  "tempJSON",
                  "tempJSON",
                  "advisors",
                  `${index}`,
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "state",
                ],
                action.payload.response.state
              )
              .setIn(
                [
                  "tempJSON",
                  "tempJSON",
                  "tempJSON",
                  "advisors",
                  `${index}`,
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "country",
                ],
                data[0].value
              )
              .setIn(["shouldEmptyZip", "shouldEmptyZip"], {
                shouldEmptyZip: true,
              });
          } else {
            return state
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "addresses",
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "city",
                ],
                action.payload.response.city
                  .toLowerCase()
                  .charAt(0)
                  .toUpperCase() +
                  action.payload.response.city.toLowerCase().slice(1)
              )
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "addresses",
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "state",
                ],
                action.payload.response.state
              )
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "addresses",
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "country",
                ],
                data[0].value
              )
              .setIn(["shouldEmptyZip", "shouldEmptyZip"], {
                shouldEmptyZip: true,
              });
          }
        } else {
          if (state.getIn(["tempJSON", "tempJSON", "tempJSON"])) {
            let index;
            if (action.payload.fetchPayload.path === "primaryAdvisor") {
              index = 0;
            } else index = 1;
            return state
              .setIn(
                [
                  "tempJSON",
                  "tempJSON",
                  "tempJSON",
                  "advisors",
                  `${index}`,
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "city",
                ],
                undefined
              )
              .setIn(
                [
                  "tempJSON",
                  "tempJSON",
                  "tempJSON",
                  "advisors",
                  `${index}`,
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "state",
                ],
                undefined
              )
              .setIn(
                [
                  "tempJSON",
                  "tempJSON",
                  "tempJSON",
                  "advisors",
                  `${index}`,
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "country",
                ],
                undefined
              )
              .setIn(["shouldEmptyZip", "shouldEmptyZip"], {
                shouldEmptyZip: false,
              });
          } else {
            return state
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "addresses",
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "city",
                ],
                undefined
              )
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "addresses",
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "state",
                ],
                undefined
              )
              .setIn(
                [
                  `${action.payload.fetchPayload.path}`,
                  "addresses",
                  "addresses",
                  `${action.payload.fetchPayload.index}`,
                  "country",
                ],
                undefined
              )
              .setIn(["shouldEmptyZip", "shouldEmptyZip"], {
                shouldEmptyZip: false,
              });
          }
        }
      }

    case actionTypes.relContributorPrimary:
      return state.setIn(["primaryAdvisor", "relatedDonor"], action.payload);

    case actionTypes.incrementDecrementCount:
      return state.setIn(["advisorCount"], action.payload);

    case actionTypes.inputChange:
      return state
        .setIn(["fundName", "fundName"], action.payload)
        .setIn(["fundNameUsedForNPAStatus"], true);

    case actionTypes.handleError:
      return state.setIn(["error"], action.payload);

    case actionTypes.storePercentage:
      let obj11 = Object.keys(action.payload);
      return state.setIn(
        ["legacyOptions", "legacyOptions"],
        action.payload[obj11[0]]
      );

    case actionTypes.storeLegacyValues:
      return state
        .setIn(["advisorCount"], {
          count: 1,
          createCount: 1,
          charityCount: 1,
        })
        .setIn(["fundName", "fundName"], {
          fundName: undefined,
        })
        .setIn(["showRemainingPercentage"], {
          showRemainingPercentage: false,
          showRemainingPercentage1: false,
          showRemainingPercentage2: false,
          showRemainingPercentage3: false,
          showRemainingPercentage4: false,
          showRemainingPercentage5: false,
        })
        .setIn(["shouldClose", "shouldClose"], {
          shouldClose: true,
        })
        .setIn(["legacyOptions", "legacyOptions"], {
          legacyOptions: [
            {
              optionId: 1,
              optionName: "Appoint up to two people",
              percentage: "",
              successorAdvisor: {
                successorAdvisor: [
                  {
                    key: "1",
                    title: "",
                    firstName: "",
                    middleName: "",
                    lastName: "",
                    suffix: "",
                    relationshipType: "",
                    dob: "",
                    gender: "",
                    preferedPhone: "",
                    preferedEmail: "",
                    address: {
                      line1: "",
                      line2: "",
                      line3: "",
                      state: "",
                      city: "",
                      zip: "",
                      country: "0",
                      zipTitle: "",
                    },
                  },
                ],
              },
            },
            {
              optionId: 2,
              optionName: "Create accounts",
              percentage: "",
              successorAdvisor: {
                successorAdvisor: [
                  {
                    key: "1",
                    title: "",
                    firstName: "",
                    middleName: "",
                    lastName: "",
                    suffix: "",
                    relationshipType: "",
                    dob: "",
                    gender: "",
                    preferedPhone: "",
                    preferedEmail: "",
                    address: {
                      line1: "",
                      line2: "",
                      line3: "",
                      state: "",
                      city: "",
                      zip: "",
                      country: "0",
                      zipTitle: "",
                    },
                  },
                ],
              },
            },
            {
              optionId: 3,
              optionName: "Philanthropic Impact Fund",
              percentage: "",
            },
            {
              optionId: 4,
              optionName: "Give to multiple charities",
              percentage: "",
              successorAdvisor: {
                successorAdvisor: [
                  {
                    key: "1",
                    name: "",
                    contactFirstName: "",
                    contactLastName: "",
                    contactPhone: "",
                    contactEmail: "",
                    charityAllocPercent: "",
                    grantRecognition: "",
                    grantPurpose: "",
                    otherGrantPurposeText: "",
                    webAddress: "",
                    ein: "",
                    address: {
                      line1: "",
                      line2: "",
                      line3: "",
                      state: "",
                      city: "",
                      zip: "",
                      country: "0",
                      zipTitle: "",
                    },
                  },
                ],
              },
            },
            {
              optionId: 5,
              optionName: "Grant annually",
              percentage: "",
            },
          ],
        });

    case actionTypes.storeSuccessorValues:
      const contentKey = action.payload.contentKey;
      const index = action.payload.successorKey;
      const key = action.payload.successorAdvisor[index]
        ? action.payload.successorAdvisor[index].key
        : null;
      let object1 = {};
      let val = state.getIn([
        "legacyOptions",
        "legacyOptions",
        "legacyOptions",
      ]);
      val.filter((data) => {
        if (data.optionId === contentKey) {
          data.successorAdvisor.successorAdvisor.filter((val2) => {
            if (val2.key === key) {
              val2.firstName = action.payload.successorAdvisor[0].firstName;
            }
          });
        }
        return;
      });

      object1.legacyOptions = val;
      return state.setIn(["legacyOptions", "legacyOptions"], object1);

    case actionTypes.addSuccessorValues:
      return state.setIn(["legacyOptions", "legacyOptions"], action.payload);

    case actionTypes.updateActivePageStepName:
      return state.set("activePageStepName", action.payload);

    case actionTypes.resetLegacy:
      return state
        .setIn(["resetLegacy"], action.payload)
        .setIn(["accordionStates"], [0, 0, 0, 0, 0])
        .setIn(["error", "accountNameError"], null);

    case actionTypes.stepTwoAccordionToggleStatus:
      return state.setIn(["accordionStatus"], action.payload);

    case actionTypes.stepTwoUpdateButton:
      return state.setIn(["updateButtonStepTwo"], action.payload);

    case actionTypes.showRemainingPercentage:
      return state
        .setIn(
          [
            "showRemainingPercentage",
            `showRemainingPercentage${action.payload.key}`,
          ],
          action.payload.value
        )
        .setIn(
          ["showRemainingPercentage", "showRemainingPercentage"],
          action.payload.showRemainingPercentage
        );

    case actionTypes.mainPercentage:
      return state.setIn(
        ["showRemainingPercentage", "showRemainingPercentage"],
        action.payload.showRemainingPercentage
      );

    case actionTypes.removeValues:
      return state.setIn(["legacyOptions", "legacyOptions"], action.payload);

    case actionTypes.shouldCloseAccordion:
      return state.setIn(["shouldClose", "shouldClose"], action.payload);

    case actionTypes.secondaryAdvisor:
      return state.setIn(
        ["isSecondaryAdvisor", "isSecondaryAdvisor"],
        action.payload
      );

    case actionTypes.showMore:
      return state.setIn(["showMore", "showMore"], action.payload);

    case actionTypes.successorTab:
      return state.setIn(["successortab"], action.payload);

    case actionTypes.stepOneEdit:
      return state.setIn(["isStep1Edit", "isStep1Edit"], action.payload);

    case actionTypes.stepTwoEdit:
      return state.setIn(["isStep2Edit", "isStep2Edit"], action.payload);

    case actionTypes.storeFinalJson:
      return state.setIn(["finalJSON"], action.payload);

    case actionTypes.storeTempJson:
      return state.setIn(["tempJSON", "tempJSON"], action.payload);

    case actionTypes.storeTempForStepOne:
      return state.setIn(
        ["tempJSON", "tempJSON", "tempJSON", "advisors"],
        action.payload
      );

    case "EST_INIT_CONTRIBUTION":
      return state.setIn(
        ["estimatedInitialContribution", "amount"],
        action.payload
      );

    case actionTypes.emptyZipStateCity:
      return state.setIn(["shouldEmptyZip", "shouldEmptyZip"], action.payload);

    case actionTypes.storeOaaEdit:
      return state.setIn(["status"], true);

    case actionTypes.updateErrState:
      if (action.payload[1]) {
        return state.setIn(
          ["legacyOptions", "legacyOptions", "legacyOptions"],
          [...action.payload[1]]
        );
      }
      return state.setIn(["error"], action.payload[0]);

    case actionTypes.updateAccordStatus:
      return state.setIn(["accordionOpenStatus"], action.payload);

    case actionTypes.updateAccordState:
      return state.setIn(["accordionStates"], action.payload);

    case actionTypes.setCityField:
      return state.setIn(["editCity"], action.payload);
    case fetchRelationDropDownSuccessType:
        return state.setIn(["relationshipValuesNew"], action.payload);
    default:
      return state;
  }
};

export default npaFormReducer;
